module.exports = __webpack_public_path__ + "static/media/B2G.bd3a4302.png";